var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-switch',{model:{value:(_vm.owngoal),callback:function ($$v) {_vm.owngoal=$$v},expression:"owngoal"}}),_c('div',{staticClass:"title"},[_vm._v("CSC")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }